// extracted by mini-css-extract-plugin
export default {"order-summary":"BaseOrderSummary_order-summary__6CozF"};